import common from '../common';
import paper from 'paper';

export default class Drawing extends PIXI.Container {
	constructor() {
		super();

		this.signals = {
			beginPath: new P3.utils.MiniSignal(),
			pathTo: new P3.utils.MiniSignal(),
			endPath: new P3.utils.MiniSignal()
		};
		this.style = {
			fill: {
				color: '#FF0000',
				stroke: true
			},
			stroke: {
				color: '#000000',
				width: 4
			}
		};

		this._enabled = true;
		this._canvas = null;
		this._drawing = false;
		this._path = null;
		this._compoundPath = null;

		this._groupedDrawing = false;       // If we have a drawing with multiple lines, we set this to true.

		this._lastPoint = new PIXI.Point();
	}

	init() {
		this._createCanvas();

		paper.setup(this._canvas[0]);
		this.update();
	}

	destroy() {
		paper.remove();
		this._canvas.remove();

		P3.utils.destroyAllSignals(this.signals);

		super.destroy({children: true});
	}

	update() {
		const mat = paper.view.matrix;
		mat.a = this.worldTransform.a;
		mat.b = this.worldTransform.b;
		mat.c = this.worldTransform.c;
		mat.d = this.worldTransform.d;
		mat.tx = this.worldTransform.tx;
		mat.ty = this.worldTransform.ty;
		mat.transform = mat;
	}

	resize() {
		paper.view.viewSize = new paper.Size(P3.View.width, P3.View.height);
	}

	beginSlot() {
		this._compoundPath = new paper.CompoundPath();
		this._compoundPath.strokeColor = this.style.stroke.color;
		this._compoundPath.strokeWidth = this.style.stroke.width;
		this._compoundPath.strokeJoin = 'round';
		this._compoundPath.strokeCap = 'round';
	}

	beginPath(point) {    
		if (!this._path) {
			const path = new paper.Path();
			path.strokeColor = this.style.stroke.color;
			path.strokeWidth = this.style.stroke.width;
			path.strokeJoin = 'round';
			path.strokeCap = 'round';
			path.moveTo(point); 
			this._path = path;
		}
	}

	pathTo(point) {
		if (this._path) {
			const path = this._path;
			this._lastPoint = point;
			path.lineTo(point);
		}
	}

	endPath() {
		let path;
		if (this._path) {
			path = this._path;
			path.simplify(common.config.drawing.simplify);

			if (this.style.fill.enabled) {
				path.fillColor = this.style.fill.color;
				this._compoundPath.fillColor = this.style.fill.color;
			}

			path.strokeWidth = this.style.fill.stroke ? path.strokeWidth : 0;

			this._compoundPath.addChild(path);
			this._path = null;
		}
		return this._compoundPath;
	}

	_createCanvas() {
		this._canvas = $('<canvas/>', {
			id: 'paper-canvas',
			width: '100%',
			height: '100%',
			hidpi: 'off',
			css: {
				'position': 'absolute',
				'left': 0 + 'px',
				'right:': 0 + 'px',
				'top': 0 + 'px',
				'bottom': 0 + 'px',
				'pointer-events': 'none'
			}
		});
		P3.View.holder.appendChild(this._canvas[0]);
		this._canvas.insertAfter('#pixi-canvas');
	}

	onPointerDown(event) {
		if (!this._enabled) return;

		const point = event.data.getLocalPosition(this);
		point.set(point.x, point.y);

		this._drawing = true;
		this.beginPath(point);

		this.signals.beginPath.dispatch(this);
	}

	onPointMove(event) {
		if (!this._enabled) return;

		const point = event.data.getLocalPosition(this);
		point.set(point.x, point.y);

		if (this._drawing) {
			this.pathTo(point);
		}
	}

	onPointerUp() {
		if (!this._enabled) return;

		this._drawing = false;
		const path = this.endPath();
		path && this.signals.endPath.dispatch(this, path);
	}

	get enabled() {
		return this._enabled;
	}

	set enabled(value) {
		this._enabled = value;
		if (this._drawing) {
			this.onPointerUp(null);
		}
	}

	set grouped(v) {
		this._groupedDrawing = v;
	}
}
